var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.29688,
    y: 1,
    width: 39,
    height: 39,
    rx: 9.5,
    fill: "white",
    stroke: "#F6EFE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_15274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.79688,
    y: 8.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_15274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7969 20.5L18.7969 16.5V19.5H10.7969V21.5H18.7969V24.5M28.7969 26.5V14.5C28.7969 13.9696 28.5862 13.4609 28.2111 13.0858C27.836 12.7107 27.3273 12.5 26.7969 12.5H14.7969C14.2664 12.5 13.7577 12.7107 13.3827 13.0858C13.0076 13.4609 12.7969 13.9696 12.7969 14.5V17.5H14.7969V14.5H26.7969V26.5H14.7969V23.5H12.7969V26.5C12.7969 27.0304 13.0076 27.5391 13.3827 27.9142C13.7577 28.2893 14.2664 28.5 14.7969 28.5H26.7969C27.3273 28.5 27.836 28.2893 28.2111 27.9142C28.5862 27.5391 28.7969 27.0304 28.7969 26.5Z",
    fill: "#9C4900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExport);
export default __webpack_public_path__ + "static/media/ic-Export.494db622210f112ec9a02eeaba749687.svg";
export { ForwardRef as ReactComponent };